import cn from "classnames"

import { QuestionCircleOutlined } from "@/icons"
import { DetectionStateIcon } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/molecules/DetectionStateIcon"

import styles from "./CardSectionTemplate.module.scss"

import type { CardSectionTemplateProps } from "."

export const CardSectionTemplate = (props: CardSectionTemplateProps) => {
  const { isSuccess, hasIncidents, variant, isMonitoring, classes = {} } = props
  const noIcon = !isSuccess && !hasIncidents

  return (
    <div
      className={cn(
        styles.container,
        noIcon && styles.containerNoIcon,
        variant === "sm" && styles.variantSm,
        classes.container
      )}
    >
      {isSuccess && (
        <>
          {isMonitoring && <DetectionStateIcon isSuccess />}
          {!isMonitoring && <QuestionCircleOutlined />}
        </>
      )}
      {hasIncidents && <DetectionStateIcon />}
      <div className={styles.wrapper}>{props.children}</div>
      {props.extra}
    </div>
  )
}
